import { useMutation, useQueryClient } from '@tanstack/react-query'

import { syncUserIdentities } from '@flecto/api/shared'

export const useMutationSyncUserIdentities = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      await syncUserIdentities()
      queryClient.invalidateQueries(['QueryGetAllIdentities'])
      queryClient.invalidateQueries(['QueryGetUserLogged'])
    },
  })
}
